// Полоса «демо» над всем интерфейсом.
//
// Показ 14-15 сентября идёт на обезличенных данных: фамилии и суммы выдуманы
// (`.claude/rules/isolation.md`, пункт 17). Без пометки человек в зале читает их как
// настоящие — а он финансовый директор, и «у Старцева висит 30 000» он запомнит.
//
// Обратная сторона важнее: если стенд по ошибке подняли на боевом контуре, полосы не будет,
// и это единственный признак, по которому мы это заметим ДО того, как настоящие фамилии
// уедут на проектор.
//
// Признак приходит с сервера ответом на вход, а не из сборки: сборка одна и та же ставится
// и на стенд, и на боевой, и различить их может только тот, кто отвечает на запросы.
//
// На бумагу полоса идёт НАМЕРЕННО, в отличие от полосы разделов: распечатанная со стенда
// ведомость с выдуманными суммами выглядит как настоящий документ, и подпись под ней ставят
// так же. Пометка на листе — единственное, что этому мешает.

import { useAuthStore } from '@/shared/auth/store';

export function DemoBanner() {
  const демо = useAuthStore((состояние) => состояние.demoBanner);
  if (!демо) {
    return null;
  }
  return (
    <div
      // Предупреждающий тон, а не красный: показ на выдуманных данных — это состояние, а не
      // сбой. Красным в продукте помечено то, что человеку надо чинить.
      className='shrink-0 bg-warning-base px-4 py-1 text-center text-paragraph-xs text-static-white'
      // Читалка экрана объявляет полосу один раз при появлении, а не на каждом переходе:
      // она не новость, а свойство всего сеанса.
      role='note'
    >
      Демонстрационный стенд: фамилии и суммы выдуманы, это не данные компании
    </div>
  );
}
